<template>
    <div>
        <el-table
          :data="creditNotes"
          stripe
          @expand-change="handleExpand"
          v-loading="creditNotesLoading">
          <div slot="empty">
            <span>{{$t('credit_notes.noCreditNote')}}</span>
          </div>
          <el-table-column type="expand">
            <template slot-scope="scope" >
                <div class="p-20">
                    <el-table
                        :data="scope.row.invoices"
                        stripe
                        empty-text="Cette note de crédit n'a été appliquée sur aucune facture"
                        style="width: 100%">
                        <el-table-column
                            prop="date"
                            :label="$t('credit_notes.invoiceNumber')">
                            <template slot-scope="scope">
                            <el-link type="primary" :underline="false" @click="downloadInvoiceReport(scope.row.invoice)">{{scope.row.invoice.invNumber}} <i class="mdi mdi-download"></i></el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('credit_notes.date')">
                            <template slot-scope="scope">
                            <span>{{formatDate(scope.row.date)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('credit_notes.invoiceTotal')">
                            <template slot-scope="props">
                            <span>{{$n(props.row.invoice.total, 'currency',scope.row.currency.code)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('credit_notes.creditedAmount')">
                            <template slot-scope="props">
                            <span>{{$n(props.row.amount,'currency',scope.row.currency.code)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('credit_notes.creditNoteNumber')" :show-overflow-tooltip="true" width="200">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click="downloadCreditNoteReport(scope.row)">{{scope.row.crNumber}} <i class="mdi mdi-download"></i></el-link>
              </template>
          </el-table-column>
          <el-table-column
            :label="$t('credit_notes.date')" :show-overflow-tooltip="true" width="120">
              <template slot-scope="scope">
                <span>{{formatDate(scope.row.date)}}</span>
              </template>
          </el-table-column>
          <el-table-column
            :label="$t('credit_notes.status')">
           <template slot-scope="scope">
               <el-tag style="margin-right:5px;" v-if="scope.row.status">{{$t('credit_notes.statuses.'+scope.row.status.code)}}</el-tag>
           </template>
         </el-table-column>
         <el-table-column
          :label="$t('credit_notes.balance')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span >{{$n(scope.row.balance.outstanding, 'currency')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  <script>
  import dayjs from 'dayjs'
  import { mapGetters, mapActions } from 'vuex';
  import creditNoteAPI from '@/services/API/creditNote';
  import invoiceAPI from '@/services/API/invoice'
  export default {
    name: 'credit-note-table',
      props: {
      customerId : {
        type : String,
        default : null
      }
      },
    data() {
      return {
        creditNotesFetched : [],
        creditNotesLoading : false,
      };
    },components: {

    },
    watch : {
      customerId : function(newVal, oldVal){
        if(newVal!=oldVal){
            this.fetchCreditNotes();
        }
      }
    },
      methods: {
        handleExpand(row, expanded) {
            const isExpanded = _.find(expanded, ex => ex.id = row.id) != null
            // on va aller chercher le détail des applications de crédits si expanded = true

            if (isExpanded) {
                invoiceAPI.fetchInvoicePaidByCreditNotes(row.id)
                    .then((invoices) => {
                        const creditNote = _.find(this.creditNotes, cn => cn.id === row.id)
                        creditNote.invoices = invoices;
                    })
            }

        },
        downloadCreditNoteReport(creditNote){
            creditNoteAPI.downloadInvoiceReport(creditNote.id, creditNote.crNumber)
        },
      fetchCreditNotes(){
        let params = {};
        params.customerId = this.customerId?this.customerId:undefined;
        if(this.filter!=null && this.filter.statusCode!=null){
          params.statusCode = this.filter.statusCode;
        }
        params.paging='no';
        this.creditNotesLoading = true;
        creditNoteAPI.fetchCreditNotesV2(params)
          .then(creditNotes=>{
            _.forEach(creditNotes, cr => {
                cr.invoices = [];
            })
            this.creditNotesFetched= creditNotes;
            this.creditNotesLoading = false;
          })
      },
      formatDate(datetime, format='YYYY-MM-DD'){
        return dayjs(datetime).format(format);
      },
      ...mapActions('invoices',['downloadInvoiceReport']),
      },
      computed: {
        creditNotes(){
            return this.creditNoteSource!=null ? this.creditNoteSrouce : this.creditNotesFetched;
        },
      ...mapGetters('customers',['customerName'])
      },
        mounted(){
            this.fetchCreditNotes();
        }
  }
  </script>
  <style lang="scss" scoped>
  
  
  
  
  </style>
  